import { type ComponentType } from 'react';
import { getModuleNameFromPath, toModuleName } from './getModuleName';

export type TResolvedModuleLoader<T = unknown> = {
    default: ComponentType<T>;
    fetcher: Promise<any>;
    ssr?: boolean;
    hydrate?: boolean;
};

const modules = import.meta.glob<TResolvedModuleLoader>(
    '../modules/**/module.ts'
);

export const exportedModules = Object.keys(modules).reduce<
    Record<string, () => Promise<TResolvedModuleLoader>>
>((acc, path) => {
    const moduleName = getModuleNameFromPath(path);
    if (!moduleName) return acc;
    acc[moduleName] = modules[path];
    return acc;
}, {});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getModuleLoader = <M = any>(
    moduleName: string | undefined
): (() => Promise<TResolvedModuleLoader<M>>) | undefined => {
    if (!moduleName) return;
    const module = exportedModules[toModuleName(moduleName)] as () => Promise<
        TResolvedModuleLoader<M>
    >;
    if (!module) return;
    return module;
};
